/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { InviteValidation, ShareValidation } from '@shared/types/validations';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ValidationsApiService {
  constructor(private http: HttpClient) {}

  validateInviteData(value: string): Observable<InviteValidation> {
    return this.http.get<InviteValidation>(`/api/v1/validations/invite?name=${encodeURIComponent(value)}`);
  }

  validateShareData(value: string): Observable<ShareValidation> {
    return this.http.get<ShareValidation>(`/api/v1/validations/share?name=${encodeURIComponent(value)}`);
  }
}
